import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _titleAppearanceBySiz, _descriptionSizeBySiz;

import React from 'react';
import PropTypes from 'prop-types';
import Description from './Description';
import Title from './Title';
import { SIZES } from '../constants';
import { APPEARANCES } from '../../Heading';
import { SIZES as TEXT_SIZES } from '../../Text';
import { classes } from '../MarketingLayout.st.css';
var titleAppearanceBySize = (_titleAppearanceBySiz = {}, _defineProperty(_titleAppearanceBySiz, SIZES.small, APPEARANCES.H3), _defineProperty(_titleAppearanceBySiz, SIZES.medium, APPEARANCES.H2), _defineProperty(_titleAppearanceBySiz, SIZES.large, APPEARANCES.H2), _titleAppearanceBySiz);
var descriptionSizeBySize = (_descriptionSizeBySiz = {}, _defineProperty(_descriptionSizeBySiz, SIZES.small, TEXT_SIZES.small), _defineProperty(_descriptionSizeBySiz, SIZES.medium, TEXT_SIZES.medium), _defineProperty(_descriptionSizeBySiz, SIZES.large, TEXT_SIZES.medium), _descriptionSizeBySiz);

var Content = function Content(_ref) {
  var size = _ref.size,
      actions = _ref.actions,
      title = _ref.title,
      description = _ref.description;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.contentContainer
  }, /*#__PURE__*/React.createElement(Title, {
    appearance: titleAppearanceBySize[size]
  }, title), /*#__PURE__*/React.createElement(Description, {
    size: descriptionSizeBySize[size]
  }, description), actions);
};

Content.propTypes = {
  size: PropTypes.string,
  actions: PropTypes.node,
  title: PropTypes.node,
  description: PropTypes.node
};
export default Content;